<p-dialog header="Assign Users" [modal]="true" 
[responsive]="true" [(visible)]="displayUsers" [style]="{ width: '50rem' }" [closable]="false"  appendTo="body" (onHide)="clearSearchInput()">
    <p-table #dt1
    [value]="activeUsers" [paginator]="true"
    [rows]="pageSize" [selectionMode]="singleSelection ? 'single' : 'multiple'" 
    [(selection)]="selectedUsers" dataKey="id"
    [(first)]="firstPage"
    [totalRecords]="lsttotalRecords" 
    [showCurrentPageReport]="true"
    [paginatorDropdownAppendTo]="'body'"
    (onRowSelect)="onSingleRowSelect($event)"
    [rowsPerPageOptions]="tableShowMore"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['name', 'emailId', 'role.role.name']"
    styleClass="p-datatable-gridlines">
    <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-end">
            <div></div>
            <span class="p-input-icon-left ml-auto ">
                <i class="pi pi-search"></i>
                <input #searchInput pInputText type="text"  (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Search Users" />
            </span>
        </div>
    </ng-template>
        <ng-template pTemplate="header">
            <tr>                
                <th *ngIf="isPermission">Permission</th>
                <th>Name</th>
                <th>Email ID</th>
                <th>Role</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr [pSelectableRow]="product">
                <td *ngIf="isPermission">
                    <p-tag *ngIf="product?.permissionType"
                    [value]="product?.permissionName"
                    [severity]="getWBPermissionStatus[product?.permissionType]">
                </p-tag>  
                </td>            
                <td>{{ product.name }}</td>
                <td>{{ product.emailId}}</td>
                <td>{{ product.role?.role?.name}}</td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeUserAssignPopup()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveAssignUser()" label="Save"></button>
    </ng-template>
</p-dialog>
